"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconMoonActive = Experimental__IconMoonActive;
exports.IconMoonActive = IconMoonActive;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconMoonActive/index.tsx)
 */
function IconMoonActive(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M6.64.51a.75.75 0 0 0-.784-.228C2.614 1.262.25 4.267.25 7.825c0 4.355 3.539 7.881 7.9 7.881a7.902 7.902 0 0 0 7.163-4.553.75.75 0 0 0-.897-1.036 6.414 6.414 0 0 1-1.86.274c-3.536 0-6.4-2.859-6.4-6.381 0-.963.214-1.875.596-2.692A.75.75 0 0 0 6.64.509ZM4.828 2.37A6.374 6.374 0 0 0 1.75 7.825c0 3.522 2.863 6.381 6.4 6.381a6.394 6.394 0 0 0 4.948-2.333 8.02 8.02 0 0 1-.541.018c-4.361 0-7.9-3.527-7.9-7.881 0-.562.059-1.11.171-1.64Z\'/><path d=\'M14.633 10.835a7.168 7.168 0 0 1-2.076.306c-3.95 0-7.15-3.193-7.15-7.131 0-1.076.239-2.095.666-3.01C3.137 1.887 1 4.607 1 7.825c0 3.938 3.201 7.131 7.15 7.131a7.152 7.152 0 0 0 6.483-4.12Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M10.999 2.674a1 1 0 0 0-1.154-1.429C5.321 2.507 2 6.658 2 11.587c0 5.928 4.806 10.735 10.735 10.735 4.128 0 7.71-2.331 9.506-5.744a1 1 0 0 0-1.154-1.428 8.744 8.744 0 0 1-2.352.32A8.735 8.735 0 0 1 10 6.735c0-1.468.361-2.849.999-4.06Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconMoonActive is deprecated and will be archived soon. Use IconMoonActive instead.
 */
function Experimental__IconMoonActive(props) {
  return /*#__PURE__*/_react["default"].createElement(IconMoonActive, props);
}